module.exports = __webpack_public_path__ + "static/img/Draw_Games_Banner_Desktop.7a67696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/Draw_Games_Banner_Desktop.jpg
// module id = Wbz5
// module chunks = 1